
{
  "actions": {
    "add": "Add Brand",
    "change": "Change Brand"
  },
  "empty": "No brand selected"
}
